import React from "react";
import ClosableModal from "components/source/shared/closable-modal";
import GridSuperBarTopFiltersAvailability from "./grid-superbar-top-filters-availability";
import { useAppDispatch, useAppSelector } from "../../../../../util/store-types";
import { isActiveMembership } from "helpers/membership-helpers";
import { MODAL_NAMES } from "constants/modal-names";
import { closeModal, openDateFilterModal } from "actions/grid-modal-actions";

type GridAvailabilityModalProps = { setMembershipAvailability: () => void };

const GridAvailabilityModal = ({ setMembershipAvailability }: GridAvailabilityModalProps) => {
  const dispatch = useAppDispatch();
  const onRequestClose = () => dispatch(closeModal());

  const displayedModal = useAppSelector(state => state.displayedModal);
  const isMobileViewport = useAppSelector(state => state.browser?.isMobileViewport);
  const isSubscriber = useAppSelector(state => isActiveMembership(state.membershipState));

  const onChange = (availabilityType: "ships_default" | "all_styles" | "specific_dates") => {
    if (availabilityType === "specific_dates") {
      dispatch(openDateFilterModal());
    } else {
      setMembershipAvailability();
      onRequestClose();
    }
  };

  const mobileStyles = {
    content: {
      bottom: 0,
    },
  };
  const styles = isMobileViewport ? mobileStyles : {};

  return (
    <ClosableModal
      additionalStyles={styles}
      isOpen={displayedModal === MODAL_NAMES.GRID_AVAILABILITY_MODAL}
      onRequestClose={onRequestClose}
      optionalClass="grid-filter-modal availability-modal grid-superbar">
      <GridSuperBarTopFiltersAvailability isSubscriber={isSubscriber} onClickBrowse={onChange} />
    </ClosableModal>
  );
};

GridAvailabilityModal.modalName = "grid-availability-modal";

export default GridAvailabilityModal;
